import React, { useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { Button } from "react-bootstrap";
import WorkshopSupplierTable from "./components/WorkshopSupplierTable";
import Swal from "sweetalert2";
import { useWorkshopSupplier } from "./context/WorkshopSupplierContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import WorkshopSupplierForm from "./components/WorkshopSupplierForm";
import { deleteRequest } from "services/api";
import WorkshopTopbar from "./components/WorkshopTopbar";

const WorkshopSupplierPage = () => {
  const { suppliers, refetch, Pagination, handleSearch, filterOptions } =
    useWorkshopSupplier();

  const { handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Workshop Supplier",
      <WorkshopSupplierForm
        onSuccess={() => {
          handleSuccessToast(true, "Supplier created successfully");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Workshop Supplier",
      <WorkshopSupplierForm
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Supplier updated successfully");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/workshop-suppliers/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Supplier deleted successfully");
          refetch();
        }
      }
    });
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-4">
        <WorkshopTopbar />
        <div className="d-flex justify-content-between mb-3">
          <SearchInput
            handleSearch={handleSearch}
            filterOptions={filterOptions}
          />
          <Button variant="primary" onClick={handleCreate}>
            + Add Supplier
          </Button>
        </div>

        <WorkshopSupplierTable
          suppliers={suppliers}
          onEdit={handleUpdate}
          onDelete={handleDelete}
          Pagination={Pagination}
        />
      </div>
    </LayoutDashboard>
  );
};

export default WorkshopSupplierPage;

const SearchInput = ({ handleSearch, filterOptions }) => {
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search suppliers..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
